
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export function useAuthRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect to login if user is not authenticated
    // Don't redirect authenticated users automatically
    supabase.auth.getSession().then(({ data }) => {
      // If there's no session and we're not already on a login/auth page,
      // redirect to login
      if (!data?.session) {
        const isAuthPage = ['/login', '/cadastro', '/recuperar-senha'].includes(location.pathname);
        if (!isAuthPage) {
          navigate("/login");
        }
      }
      // If user is authenticated, we do nothing - they stay on their current page
    });
  }, [navigate, location.pathname]);
}
